import * as tools from '../../actions/early/tools'

const initialState = {
  isToolPopupOpened: false,
  selectedToolId: null,
  toolCache: {
    22101900: { id: '22101900', name: 'Building construction machinery and accessories' },
    43211900: { id: '43211900', name: 'Computer displays' },
    31241700: { id: '31241700', name: 'Mirrors' },
    27141100: { id: '27141100', name: 'Suspension tools' },
    56111900: { id: '56111900', name: 'Industrial furniture' },
    25131500: { id: '25131500', name: 'Powered fixed wing aircraft' },
    42295400: { id: '42295400', name: 'Surgical support supplies' },
    60124300: {
      id: '60124300',
      name: 'Clay and modeling compounds and ceramics equipment and accessories'
    },
    31151900: { id: '31151900', name: 'Straps' },
    42281500: {
      id: '42281500',
      name: 'Autoclave and sterilizer equipment and accessories'
    },
    20141300: { id: '20141300', name: 'Downhole jet pumps and anchors' },
    41123400: { id: '41123400', name: 'Dosing devices' },
    42201600: { id: '42201600', name: 'Medical magnetic resonance imaging MRI products' },
    47101500: { id: '47101500', name: 'Water treatment and supply equipment' },
    23271800: { id: '23271800', name: 'Welding and soldering and brazing supplies' },
    42271900: { id: '42271900', name: 'Airway management products' },
    42291500: {
      id: '42291500',
      name: 'Surgical bone biopsy instruments and related products'
    },
    52141800: { id: '52141800', name: 'Other domestic household appliances' },
    43223100: {
      id: '43223100',
      name: 'Digital mobile network infrastructure equipment and components'
    },
    42142100: { id: '42142100', name: 'Heat and cold therapy products' },
    47121600: { id: '47121600', name: 'Floor machines and accessories' },
    42151900: {
      id: '42151900',
      name: 'Dental hygiene and preventive care equipment and supplies'
    },
    41115400: { id: '41115400', name: 'Spectroscopic equipment' },
    47111500: { id: '47111500', name: 'Washing and drying equipment' },
    48101800: { id: '48101800', name: 'Cookware and kitchen tools' },
    42142000: { id: '42142000', name: 'Floor grade instruments' },
    42181700: {
      id: '42181700',
      name: 'Electrocardiography EKG units and related products'
    },
    60131500: { id: '60131500', name: 'Musical instrument parts and accessories' },
    44101900: { id: '44101900', name: 'Check endorsing and writing machines' },
    56101500: { id: '56101500', name: 'Furniture' },
    40102000: { id: '40102000', name: 'Boilers' },
    53141500: { id: '53141500', name: 'Sewing fasteners' },
    46191600: { id: '46191600', name: 'Fire fighting equipment' },
    25202500: { id: '25202500', name: 'Aircraft equipment' },
    49161500: { id: '49161500', name: 'Field sports equipment' },
    44102500: { id: '44102500', name: 'Sorting machines' },
    25202200: { id: '25202200', name: 'Aircraft landing and braking systems' },
    60141400: { id: '60141400', name: 'Dramatic play equipment and accessories' },
    39122200: { id: '39122200', name: 'Electrical switches and accessories' },
    46182300: { id: '46182300', name: 'Fall protection and rescue equipment' },
    42212300: {
      id: '42212300',
      name: 'Reaching and gripping aids for the physically challenged'
    },
    31251500: { id: '31251500', name: 'Actuators' },
    23281600: { id: '23281600', name: 'Heat treating machines' },
    26121600: { id: '26121600', name: 'Electrical cable and accessories' },
    32121700: { id: '32121700', name: 'Discrete components' },
    42131700: { id: '42131700', name: 'Surgical textiles' },
    23161500: { id: '23161500', name: 'Foundry machines and equipment' },
    42222300: { id: '42222300', name: 'Blood administration and transfusion products' },
    39112200: { id: '39112200', name: 'Special effects devices' },
    41115300: {
      id: '41115300',
      name: 'Light and wave generating and measuring equipment'
    },
    42281800: { id: '42281800', name: 'Sterilization indicators and controls' },
    27112100: { id: '27112100', name: 'Holding and clamping tools' },
    46182500: { id: '46182500', name: 'Personal safety devices or weapons' },
    20141500: { id: '20141500', name: 'Downhole pumps' },
    40161600: { id: '40161600', name: 'Purification' },
    23152000: {
      id: '23152000',
      name: 'Web handling and control machinery and equipment and supplies'
    },
    42161500: {
      id: '42161500',
      name: 'Peritoneal and equilibrium dialysis equipment and supplies'
    },
    41104500: { id: '41104500', name: 'Laboratory ovens and accessories' },
    20102300: { id: '20102300', name: 'Underground mining service vehicles' },
    42242100: { id: '42242100', name: 'Orthopedic traction supplies and accessories' },
    32141000: { id: '32141000', name: 'Electron Tubes' },
    42201700: {
      id: '42201700',
      name: 'Medical ultrasound and doppler and echo imaging products'
    },
    42203500: { id: '42203500', name: 'Cardiac pacemakers and related products' },
    49201500: { id: '49201500', name: 'Aerobic training equipment' },
    42281900: { id: '42281900', name: 'Sterilization wraps and packaging supplies' },
    42181500: {
      id: '42181500',
      name: 'Diagnostic assessment and exam products for general use'
    },
    42272500: {
      id: '42272500',
      name: 'Anesthesia apparatus and accessories and supplies'
    },
    23221100: {
      id: '23221100',
      name: 'Killing and defeathering department machinery and equipment'
    },
    23191000: { id: '23191000', name: 'Batch mixers' },
    41113000: { id: '41113000', name: 'Chemical evaluation instruments and supplies' },
    48121100: { id: '48121100', name: 'Coin operated gambling machines' },
    42212200: {
      id: '42212200',
      name: 'Medication handling aids for the physically challenged'
    },
    42201500: {
      id: '42201500',
      name: 'Medical computed tomography CT or CAT systems and related products'
    },
    23281900: { id: '23281900', name: 'Metal cleaning machinery and supplies' },
    31151500: { id: '31151500', name: 'Ropes' },
    42272300: { id: '42272300', name: 'Resuscitation supplies' },
    39112500: { id: '39112500', name: 'Stage and studio luminaires' },
    25201600: {
      id: '25201600',
      name: 'Aerospace location and navigation systems and components'
    },
    10111300: {
      id: '10111300',
      name: 'Domestic pet treatments and accessories and equipment'
    },
    26101700: { id: '26101700', name: 'Engine components and accessories' },
    43231500: { id: '43231500', name: 'Business function specific software' },
    31163100: { id: '31163100', name: 'Connectors' },
    49171500: { id: '49171500', name: 'Gymnastics equipment' },
    41106300: {
      id: '41106300',
      name:
        'Polymerase chain reaction PCR and reverse transcriptase polymerase chain reaction RT PCR products'
    },
    44101700: {
      id: '44101700',
      name: 'Printer and photocopier and facsimile accessories'
    },
    14111500: { id: '14111500', name: 'Printing and writing paper' },
    42294900: {
      id: '42294900',
      name: 'Endoscopic instruments and supplies and accessories and related products'
    },
    42192600: {
      id: '42192600',
      name: 'Medication dispensing and measuring devices and supplies'
    },
    60103900: {
      id: '60103900',
      name: 'Living organisms and preserved specimens and related materials'
    },
    42182000: {
      id: '42182000',
      name: 'Scopes and specula and accessories for medical exam diagnostic use'
    },
    31141600: { id: '31141600', name: 'Vacuum moldings' },
    25191500: {
      id: '25191500',
      name: 'Air transportation support systems and equipment'
    },
    41111500: { id: '41111500', name: 'Weight measuring instruments' },
    60104800: { id: '60104800', name: 'Wave and sound physics materials' },
    45121700: { id: '45121700', name: 'Photographic processing equipment' },
    27121600: { id: '27121600', name: 'Hydraulic cylinders and pistons' },
    41103900: { id: '41103900', name: 'Laboratory centrifuges and accessories' },
    42271500: { id: '42271500', name: 'Respiratory monitoring products' },
    31141500: { id: '31141500', name: 'Injection moldings' },
    41104200: {
      id: '41104200',
      name: 'Laboratory water purification equipment and supplies'
    },
    56111800: { id: '56111800', name: 'Freestanding furniture' },
    41122800: { id: '41122800', name: 'Laboratory stands and racks and trays' },
    52141600: { id: '52141600', name: 'Domestic laundry appliances and supplies' },
    42182700: { id: '42182700', name: 'Medical exam size measuring devices' },
    43201500: { id: '43201500', name: 'System boards processors interfaces or modules' },
    60105000: { id: '60105000', name: 'Nuclear physics materials' },
    45121600: { id: '45121600', name: 'Camera accessories' },
    44103100: { id: '44103100', name: 'Printer and facsimile and photocopier supplies' },
    23181600: { id: '23181600', name: 'Food cutting machinery' },
    23131600: { id: '23131600', name: 'Faceting equipment and accessories' },
    44111800: { id: '44111800', name: 'Drafting supplies' },
    43232700: { id: '43232700', name: 'Network applications software' },
    42241500: { id: '42241500', name: 'Casting and splinting supplies' },
    46161700: { id: '46161700', name: 'Rescue equipment and accessories' },
    40142000: { id: '40142000', name: 'Hoses' },
    60123500: { id: '60123500', name: 'Leather craft materials' },
    41114200: { id: '41114200', name: 'Land surveying instruments' },
    27131600: { id: '27131600', name: 'Air fittings and connectors' },
    42301500: { id: '42301500', name: 'Aids for medical training' },
    30121800: { id: '30121800', name: 'Landscape architecture materials' },
    26111500: { id: '26111500', name: 'Kinetic power transmission' },
    60141100: { id: '60141100', name: 'Games' },
    42152600: { id: '42152600', name: 'Dental operatory specific supplies' },
    43232500: { id: '43232500', name: 'Educational or reference software' },
    45111900: {
      id: '45111900',
      name: 'Phone and video conference equipment and hardware and controllers'
    },
    20121100: { id: '20121100', name: 'Cementing equipment' },
    42292700: {
      id: '42292700',
      name: 'Surgical dissectors and elevators and picks and related products'
    },
    42311500: { id: '42311500', name: 'Bandages and dressings and related products' },
    44121600: { id: '44121600', name: 'Desk supplies' },
    60131400: { id: '60131400', name: 'Percussion instruments' },
    27121700: { id: '27121700', name: 'Hydraulic hose and tube fittings' },
    42152100: {
      id: '42152100',
      name: 'Dental impression and forming equipment and supplies'
    },
    43232300: { id: '43232300', name: 'Data management and query software' },
    26101200: { id: '26101200', name: 'Electric direct current DC motors' },
    20122400: { id: '20122400', name: 'Production systems equipment' },
    42294800: { id: '42294800', name: 'Endoscopes and accessories and related products' },
    42292200: {
      id: '42292200',
      name: 'Surgical approximators and compressors and depressors and related products'
    },
    56122000: { id: '56122000', name: 'Laboratory furniture' },
    24112000: { id: '24112000', name: 'Bins and baskets' },
    55121500: { id: '55121500', name: 'Tags' },
    41113300: { id: '41113300', name: 'Liquid and solid and elemental analyzers' },
    21102000: {
      id: '21102000',
      name: 'Agricultural machinery for cleaning and sorting and grading'
    },
    42151600: { id: '42151600', name: 'Dental and subspecialty instruments and devices' },
    39121400: { id: '39121400', name: 'Electrical lugs plugs and connectors' },
    43223300: {
      id: '43223300',
      name: 'Datacom and network connectivity installation devices and equipment'
    },
    46181700: { id: '46181700', name: 'Face and head protection' },
    43211700: { id: '43211700', name: 'Computer data input devices' },
    41104400: { id: '41104400', name: 'Laboratory incubating equipment' },
    41114500: { id: '41114500', name: 'Mechanical instruments' },
    25173700: { id: '25173700', name: 'Exhaust and emission controls' },
    32121600: { id: '32121600', name: 'Resistors' },
    27111700: { id: '27111700', name: 'Wrenches and drivers' },
    20122900: { id: '20122900', name: 'Surface data logging equipment' },
    41103200: { id: '41103200', name: 'Laboratory washing and cleaning equipment' },
    42291900: {
      id: '42291900',
      name: 'Surgical instrument and tube holders and positioners'
    },
    25174800: { id: '25174800', name: 'Specialized vehicle systems and components' },
    42211700: {
      id: '42211700',
      name: 'Communication aids for the physically challenged'
    },
    93151700: { id: '93151700', name: 'Currency' },
    60101800: { id: '60101800', name: 'Church school educational resources' },
    42143600: { id: '42143600', name: 'Restraints and accessories' },
    26141800: { id: '26141800', name: 'Hot cell devices' },
    27112700: { id: '27112700', name: 'Power tools' },
    43211500: { id: '43211500', name: 'Computers' },
    10131700: { id: '10131700', name: 'Animal habitats' },
    42121500: { id: '42121500', name: 'Veterinary equipment' },
    20102000: { id: '20102000', name: 'Exploration and development systems' },
    54111700: { id: '54111700', name: 'Watch or clock parts or accessories' },
    26142400: { id: '26142400', name: 'Radioactive waste equipment' },
    48121200: { id: '48121200', name: 'Gambling tables and games' },
    23201000: { id: '23201000', name: 'Gas liquid contacting systems' },
    60131600: { id: '60131600', name: 'Musical instrument sets' },
    42203600: {
      id: '42203600',
      name: 'Medical radiological imaging information and archiving products'
    },
    42293300: {
      id: '42293300',
      name: 'Surgical distractors and spreaders and separators and related products'
    },
    25174200: { id: '25174200', name: 'Steering system' },
    42293500: {
      id: '42293500',
      name:
        'Surgical suction and irrigation cannulas and tips and stylets and related products'
    },
    49241700: { id: '49241700', name: 'Swimming pool and spa equipment and supplies' },
    42142600: { id: '42142600', name: 'Syringes and accessories' },
    41112500: {
      id: '41112500',
      name: 'Liquid and gas flow measuring and observing instruments'
    },
    23141700: {
      id: '23141700',
      name: 'Leather working and repairing machinery and accessories'
    },
    53131600: { id: '53131600', name: 'Bath and body' },
    41112100: { id: '41112100', name: 'Transducers' },
    23153000: {
      id: '23153000',
      name: 'Holding and positioning and guiding systems and devices'
    },
    46181900: { id: '46181900', name: 'Hearing protectors' },
    42312100: {
      id: '42312100',
      name: 'Ostomy supplies and non surgical wound drainage products'
    },
    23152200: { id: '23152200', name: 'Manufacturing tables and stands' },
    20142100: { id: '20142100', name: 'Heater treaters' },
    60123700: { id: '60123700', name: 'Macrame craft materials and accessories' },
    41112700: { id: '41112700', name: 'Seed and feed equipment' },
    41105500: {
      id: '41105500',
      name:
        'Nucleic acid extraction and purification and quantitation kits and components'
    },
    24102200: { id: '24102200', name: 'Packing tools' },
    25173100: { id: '25173100', name: 'Location and navigation systems and components' },
    54101700: { id: '54101700', name: 'Jewelry making tools and supplies' },
    42143100: {
      id: '42143100',
      name: 'Obstetrical and gynecological equipment and supplies'
    },
    43233700: { id: '43233700', name: 'System management software' },
    42295200: {
      id: '42295200',
      name: 'Surgical power equipment and accessories and related products'
    },
    60122200: { id: '60122200', name: 'Wood crafts' },
    41111800: { id: '41111800', name: 'Non destructive examination equipment' },
    45111500: { id: '45111500', name: 'Lecterns and sound systems and accessories' },
    43223000: { id: '43223000', name: 'Teletype equipment' },
    44101500: { id: '44101500', name: 'Duplicating machines' },
    41122200: { id: '41122200', name: 'Crucibles' },
    42261800: {
      id: '42261800',
      name: 'Cadaver transport and storage equipment and supplies'
    },
    25202000: { id: '25202000', name: 'Aircraft power systems' },
    20121500: { id: '20121500', name: 'Conventional drilling tools' },
    52141700: { id: '52141700', name: 'Domestic bath appliances' },
    39101600: { id: '39101600', name: 'Lamps and lightbulbs' },
    42152200: {
      id: '42152200',
      name: 'Dental laboratory and sterilization equipment and supplies'
    },
    42202300: {
      id: '42202300',
      name:
        'Medical linear accelerator intensity modulated radiation therapy IMRT products'
    },
    42312200: { id: '42312200', name: 'Suture and related products' },
    43201800: { id: '43201800', name: 'Media storage devices' },
    49201600: { id: '49201600', name: 'Weight and resistance training equipment' },
    31161800: { id: '31161800', name: 'Washers' },
    42192200: { id: '42192200', name: 'Patient transport products' },
    40101500: { id: '40101500', name: 'Ventilation' },
    41106100: { id: '41106100', name: 'Deoxyribonucleic acid DNA analysis kits' },
    30191500: { id: '30191500', name: 'Ladders and scaffolding' },
    42191900: { id: '42191900', name: 'Clinical cabinetry' },
    60121200: {
      id: '60121200',
      name: 'Classroom and fine art paint and mediums and applicators and accessories'
    },
    23141600: { id: '23141600', name: 'Leather preparing machinery and accessories' },
    23153500: { id: '23153500', name: 'Paint systems' },
    48121300: {
      id: '48121300',
      name: 'Gambling management and networked wagering systems'
    },
    55121700: { id: '55121700', name: 'Signage' },
    21101800: {
      id: '21101800',
      name: 'Dispersing and spraying appliances for agriculture'
    },
    60131200: { id: '60131200', name: 'Woodwind instruments' },
    42203000: {
      id: '42203000',
      name: 'Medical linear accelerators and related products'
    },
    24111800: { id: '24111800', name: 'Tanks and cylinders and their accessories' },
    54111500: { id: '54111500', name: 'Watches' },
    52151700: { id: '52151700', name: 'Domestic flatware and cutlery' },
    41122600: { id: '41122600', name: 'Laboratory microscope slides and supplies' },
    25121700: { id: '25121700', name: 'Railroad support equipment and systems' },
    23121500: { id: '23121500', name: 'Textile processing machinery and accessories' },
    44121900: { id: '44121900', name: 'Ink and lead refills' },
    24131900: { id: '24131900', name: 'Ice makers' },
    42202700: { id: '42202700', name: 'Radiotherapy teletherapy products' },
    23181800: { id: '23181800', name: 'Industrial beverage processing machinery' },
    10131600: { id: '10131600', name: 'Animal containment' },
    31211900: { id: '31211900', name: 'Paint applicators and painting accessories' },
    25101700: { id: '25101700', name: 'Safety and rescue vehicles' },
    42293000: { id: '42293000', name: 'Surgical measuring devices and related products' },
    25191700: { id: '25191700', name: 'Vehicle servicing equipment' },
    10141600: { id: '10141600', name: 'Harness goods' },
    42293100: { id: '42293100', name: 'Surgical retractors and related products' },
    46191500: { id: '46191500', name: 'Fire prevention' },
    43232000: { id: '43232000', name: 'Computer game or entertainment software' },
    42292900: {
      id: '42292900',
      name: 'Suture and surgical tissue closure instruments and related products'
    },
    42144100: { id: '42144100', name: 'Pleural cavity drain products' },
    41105100: { id: '41105100', name: 'Laboratory pumps and tubing' },
    23191100: { id: '23191100', name: 'Continuous mixers' },
    42261500: { id: '42261500', name: 'Pathology dissection instruments and supplies' },
    43201400: { id: '43201400', name: 'System Cards' },
    23271600: { id: '23271600', name: 'Soldering machines' },
    45101900: { id: '45101900', name: 'Printing laboratory equipment and accessories' },
    42222200: {
      id: '42222200',
      name: 'Needleless intravenous injection and withdrawal systems'
    },
    56131500: { id: '56131500', name: 'Mannequins and forms' },
    60104600: { id: '60104600', name: 'Mechanical physics materials' },
    40142500: { id: '40142500', name: 'Traps and strainers' },
    42141600: {
      id: '42141600',
      name: 'Basins and bedpans and urinals and admission kits'
    },
    23251800: { id: '23251800', name: 'Metal forming dies and tooling' },
    27112200: { id: '27112200', name: 'Masonry and concrete tools' },
    21101900: { id: '21101900', name: 'Poultry and livestock equipment' },
    42311900: {
      id: '42311900',
      name:
        'Medical incision drains and drainage bags and reservoirs and related products'
    },
    43221700: { id: '43221700', name: 'Fixed network equipment and components' },
    42295100: {
      id: '42295100',
      name: 'Surgical equipment and accessories and related products'
    },
    31242100: { id: '31242100', name: 'Optical device accessories' },
    41104700: {
      id: '41104700',
      name: 'Laboratory freeze dryers and lyopholizers and accessories'
    },
    30181600: { id: '30181600', name: 'Non sanitary residential fixtures' },
    44111600: { id: '44111600', name: 'Cash handling supplies' },
    24101700: { id: '24101700', name: 'Conveyors and accessories' },
    60122100: { id: '60122100', name: 'Candlemaking' },
    42212100: {
      id: '42212100',
      name: 'Leisure and recreational aids for the physically challenged'
    },
    51121600: { id: '51121600', name: 'Antianginal drugs' },
    31162900: { id: '31162900', name: 'Clamps' },
    31201500: { id: '31201500', name: 'Tape' },
    20142700: { id: '20142700', name: 'Pumping units' },
    42131600: { id: '42131600', name: 'Medical staff clothing and related articles' },
    41121800: {
      id: '41121800',
      name: 'General laboratory glassware and plasticware and supplies'
    },
    25131600: { id: '25131600', name: 'Civilian and commercial rotary wing aircraft' },
    27111900: { id: '27111900', name: 'Rough and finishing tools' },
    45101700: { id: '45101700', name: 'Printing accessories' },
    26111600: { id: '26111600', name: 'Power generators' },
    43222500: { id: '43222500', name: 'Network security equipment' },
    26142200: { id: '26142200', name: 'Nuclear fuel equipment' },
    23241900: { id: '23241900', name: 'Metal boring machines' },
    47131900: { id: '47131900', name: 'Absorbents' },
    23153200: { id: '23153200', name: 'Robotics' },
    42231900: { id: '42231900', name: 'Breast feeding equipment and supplies' },
    27112300: { id: '27112300', name: 'Marking tools' },
    42221800: {
      id: '42221800',
      name: 'Intravenous and arterial catheter and needle positioning aids'
    },
    41116100: {
      id: '41116100',
      name: 'Manual test kits and quality controls and calibrators and standards'
    },
    41103800: {
      id: '41103800',
      name: 'Laboratory mixing and stirring and shaking equipment and supplies'
    },
    42272200: {
      id: '42272200',
      name: 'Positive mechanical pressure ventilators and accessories'
    },
    44102600: { id: '44102600', name: 'Typing machines and accessories' },
    42242000: { id: '42242000', name: 'Prosthetic devices or accessories and supplies' },
    41114300: { id: '41114300', name: 'Hydrological instruments' },
    43222600: { id: '43222600', name: 'Network service equipment' },
    42202100: { id: '42202100', name: 'Brachytherapy products' },
    43233200: { id: '43233200', name: 'Security and protection software' },
    42291700: {
      id: '42291700',
      name:
        'Surgical hand drills and reamers and puncturing instruments and accessories and related products'
    },
    42152800: { id: '42152800', name: 'Periodontal equipment and supplies' },
    40101800: { id: '40101800', name: 'Heating equipment and parts and accessories' },
    20122600: { id: '20122600', name: 'Seismic equipment' },
    25172200: { id: '25172200', name: 'Vehicle doors' },
    42161800: {
      id: '42161800',
      name: 'Continuous renal replacement therapy CRRT equipment and supplies'
    },
    23151500: {
      id: '23151500',
      name: 'Rubber and plastic processing machinery and equipment and supplies'
    },
    20142500: { id: '20142500', name: 'Produced water treating equipment' },
    31163300: { id: '31163300', name: 'Studs' },
    25101800: { id: '25101800', name: 'Motorized cycles' },
    42183000: { id: '42183000', name: 'Ophthalmic diagnostic exam products' },
    41106200: {
      id: '41106200',
      name: 'Microorganism propagation and transformation media and kits and equipment'
    },
    27112900: { id: '27112900', name: 'Dispensing tools' },
    31191500: { id: '31191500', name: 'Abrasives and abrasive media' },
    25111800: { id: '25111800', name: 'Recreational watercraft' },
    42151800: {
      id: '42151800',
      name: 'Dental fillers and finishing and polishing supplies'
    },
    42294700: {
      id: '42294700',
      name:
        'Open heart perfusion equipment and monitors and accessories and related products'
    },
    56101700: { id: '56101700', name: 'Office furniture' },
    23242100: { id: '23242100', name: 'Metal cutting machine attachments' },
    26101300: { id: '26101300', name: 'Non electric motors' },
    42203700: {
      id: '42203700',
      name: 'Medical imaging processing equipment and supplies'
    },
    40161500: { id: '40161500', name: 'Filters' },
    42251800: {
      id: '42251800',
      name: 'Work hardening equipment for rehabilitation or therapy'
    },
    42182100: { id: '42182100', name: 'Stethoscopes and related products' },
    42272000: { id: '42272000', name: 'Intubation supplies' },
    32151700: { id: '32151700', name: 'Programmable Logic Controllers' },
    42222000: {
      id: '42222000',
      name: 'Intravenous infusion pumps and its analyzers and sensors and its accessories'
    },
    42142800: {
      id: '42142800',
      name: 'Vascular and compression therapy equipment and supplies'
    },
    46151500: { id: '46151500', name: 'Crowd control equipment' },
    26131500: { id: '26131500', name: 'Power plants' },
    60123600: { id: '60123600', name: 'Glitter' },
    48111100: { id: '48111100', name: 'Piece and part vending machines' },
    23241400: { id: '23241400', name: 'Metal grinding machines' },
    26131800: { id: '26131800', name: 'Power generation control equipment' },
    23241700: { id: '23241700', name: 'Metal deburring machines' },
    43202000: { id: '43202000', name: 'Removable storage media' },
    43191500: { id: '43191500', name: 'Personal communication devices' },
    47121800: { id: '47121800', name: 'Cleaning equipment' },
    21111500: { id: '21111500', name: 'Commercial fishing equipment' },
    39131500: { id: '39131500', name: 'Wire Markers and Wire Marking Devices' },
    20122800: { id: '20122800', name: 'Drilling and workover rigs and equipment' },
    39111600: { id: '39111600', name: 'Exterior lighting fixtures and accessories' },
    30191600: { id: '30191600', name: 'Ladders and scaffolding accessories' },
    41104800: {
      id: '41104800',
      name:
        'Laboratory decanting and distilling and evaporating and extracting equipment and supplies'
    },
    31162000: { id: '31162000', name: 'Nails' },
    46171600: { id: '46171600', name: 'Surveillance and detection equipment' },
    25171600: { id: '25171600', name: 'Defrosting and defogging systems' },
    44101800: { id: '44101800', name: 'Calculating machines and accessories' },
    53102600: { id: '53102600', name: 'Nightwear' },
    31162800: { id: '31162800', name: 'Miscellaneous hardware' },
    41123300: {
      id: '41123300',
      name: 'General laboratory storage containers and cabinets'
    },
    42293600: {
      id: '42293600',
      name: 'Surgical bougies and sounds and obturators and related products'
    },
    31241800: { id: '31241800', name: 'Optical filters' },
    40161800: { id: '40161800', name: 'Filter media' },
    23152100: { id: '23152100', name: 'Separation machinery and equipment' },
    49161700: { id: '49161700', name: 'Track sports equipment' },
    30241500: { id: '30241500', name: 'Portable Structure Consolidating Components' },
    42272100: { id: '42272100', name: 'Negative mechanical pressure ventilators' },
    47111700: { id: '47111700', name: 'Dry cleaning equipment' },
    53102500: { id: '53102500', name: 'Clothing accessories' },
    22101600: { id: '22101600', name: 'Paving equipment' },
    41103400: { id: '41103400', name: 'Laboratory environmental conditioning equipment' },
    42191800: { id: '42191800', name: 'Patient beds and accessories' },
    20141000: { id: '20141000', name: 'Wellhead equipment' },
    45101600: { id: '45101600', name: 'Printing machinery accessories' },
    23111500: {
      id: '23111500',
      name: 'Petroleum distilling and processing machinery and equipment'
    },
    42271600: {
      id: '42271600',
      name: 'Pulmonary function testing and treatment products'
    },
    41101700: {
      id: '41101700',
      name:
        'Laboratory boring and grinding and cutting and crushing and pressing equipment'
    },
    43221500: { id: '43221500', name: 'Call management systems or accessories' },
    27112600: { id: '27112600', name: 'Sealing tools' },
    42211900: {
      id: '42211900',
      name: 'Eating and drinking and food preparation aids for the physically challenged'
    },
    24112400: { id: '24112400', name: 'Storage chests and cabinets and trunks' },
    24101600: { id: '24101600', name: 'Lifting equipment and accessories' },
    42171700: { id: '42171700', name: 'Emergency medical services blankets' },
    23271700: { id: '23271700', name: 'Welding and soldering and brazing accessories' },
    42182200: { id: '42182200', name: 'Medical thermometers and accessories' },
    60121700: { id: '60121700', name: 'Printmaking supplies and accessories' },
    23291700: { id: '23291700', name: 'Industrial reaming tools' },
    31162700: { id: '31162700', name: 'Rolling hardware' },
    46182100: { id: '46182100', name: 'Anti static equipment and supplies' },
    20121900: { id: '20121900', name: 'Well measurement and logging equipment' },
    41103000: { id: '41103000', name: 'Laboratory cooling equipment' },
    48101600: { id: '48101600', name: 'Food preparation equipment' },
    26142100: { id: '26142100', name: 'Nuclear reactor equipment' },
    27113300: { id: '27113300', name: 'Precision hand tools' },
    25202700: { id: '25202700', name: 'Aircraft accumulators' },
    42312500: { id: '42312500', name: 'Wound supports and supplies and accessories' },
    53141600: { id: '53141600', name: 'Miscellaneous sewing supplies' },
    11111600: { id: '11111600', name: 'Stone' },
    42294000: {
      id: '42294000',
      name: 'Surgical spatulas and spoons and scoops and related products'
    },
    60131000: { id: '60131000', name: 'Keyboard instruments' },
    39122300: { id: '39122300', name: 'Electrical relays and accessories' },
    24101500: { id: '24101500', name: 'Industrial trucks' },
    25121500: { id: '25121500', name: 'Locomotives and electric trolleys' },
    42231500: { id: '42231500', name: 'Enteral feeding equipment and supplies' },
    41122100: {
      id: '41122100',
      name: 'Tissue culture and high throughput screening supplies'
    },
    56101800: { id: '56101800', name: 'Baby and toddler furniture and accessories' },
    42192000: { id: '42192000', name: 'Clinical procedure and examination tables' },
    52161600: { id: '52161600', name: 'Audio visual equipment accessories' },
    49161600: { id: '49161600', name: 'Racquet and court sports equipment' },
    42251600: { id: '42251600', name: 'Rehabilitation exercise devices and equipment' },
    23242500: { id: '23242500', name: 'Metal milling machines' },
    42171600: {
      id: '42171600',
      name:
        'Emergency medical services extricating and immobilizing and transporting products'
    },
    23151900: {
      id: '23151900',
      name: 'Paper making and paper processing machinery and equipment and supplies'
    },
    20121400: { id: '20121400', name: 'Completion tools and equipment' },
    60104900: { id: '60104900', name: 'Electrical physics materials' },
    42203100: { id: '42203100', name: 'Radiobiological instruments' },
    45111600: { id: '45111600', name: 'Projectors and supplies' },
    41103700: { id: '41103700', name: 'Laboratory baths' },
    26131700: {
      id: '26131700',
      name: 'Power generation monitoring or detecting equipment'
    },
    42161600: {
      id: '42161600',
      name: 'Extracorporeal hemodialysis equipment and supplies'
    },
    41113600: {
      id: '41113600',
      name: 'Electrical measuring and testing equipment and accessories'
    },
    42262100: { id: '42262100', name: 'Mortuary equipment and supplies' },
    24101900: { id: '24101900', name: 'Drum handling equipment' },
    41111600: {
      id: '41111600',
      name: 'Length and thickness and distance measuring instruments'
    },
    41103300: { id: '41103300', name: 'Fluid mechanics equipment' },
    47111600: { id: '47111600', name: 'Ironing equipment' },
    23291800: { id: '23291800', name: 'Industrial threading tools' },
    41113900: { id: '41113900', name: 'Soil measuring equipment' },
    25161500: { id: '25161500', name: 'Pedal powered vehicles' },
    42152400: { id: '42152400', name: 'Dental materials' },
    27111800: { id: '27111800', name: 'Measuring and layout tools' },
    42172200: { id: '42172200', name: 'Emergency medical services supplies' },
    49181600: { id: '49181600', name: 'Target games and equipment' },
    42261700: { id: '42261700', name: 'Autopsy furniture' },
    44102100: { id: '44102100', name: 'Mail machines' },
    60131300: { id: '60131300', name: 'String instruments' },
    40141600: { id: '40141600', name: 'Valves' },
    23241800: { id: '23241800', name: 'Metal drilling machines' },
    42171500: {
      id: '42171500',
      name: 'Emergency medical services disaster management products'
    },
    25175000: { id: '25175000', name: 'Electric vehicle charging systems' },
    46171500: { id: '46171500', name: 'Locks and security hardware and accessories' },
    60124500: { id: '60124500', name: 'Sculpture supplies and accessories' },
    23241500: { id: '23241500', name: 'Metal cutting machines' },
    42172000: { id: '42172000', name: 'Emergency and field medical services kits' },
    25181700: { id: '25181700', name: 'Product and material trailers' },
    10191700: { id: '10191700', name: 'Pest control devices' },
    95121600: { id: '95121600', name: 'Transport buildings and structures' },
    42182300: { id: '42182300', name: 'Neurological exam products' },
    41105300: {
      id: '41105300',
      name: 'Laboratory electrophoresis and blotting system and supplies'
    },
    42281700: {
      id: '42281700',
      name: 'Disinfecting or presterilization cleaning equipment and solutions'
    },
    41115700: {
      id: '41115700',
      name: 'Chromatographic measuring instruments and accessories'
    },
    42182400: { id: '42182400', name: 'Hearing testing products' },
    60131100: { id: '60131100', name: 'Brass instruments' },
    21111600: { id: '21111600', name: 'Aquaculture equipment' },
    43212100: { id: '43212100', name: 'Computer printers' },
    42202000: {
      id: '42202000',
      name: 'Medical diagnostic gamma cameras and related products'
    },
    46101800: { id: '46101800', name: 'Arms and ammunition accessories' },
    23231100: { id: '23231100', name: 'Bandsaws and accessories' },
    56101900: { id: '56101900', name: 'General furniture parts and accessories' },
    43232900: { id: '43232900', name: 'Networking software' },
    60105600: {
      id: '60105600',
      name: 'Health education and nutrition and food preparation instructional materials'
    },
    27113200: { id: '27113200', name: 'Tool kits' },
    41104600: { id: '41104600', name: 'Laboratory furnaces and accessories' },
    41106600: { id: '41106600', name: 'Vectors' },
    20122300: { id: '20122300', name: 'Slickline equipment' },
    23152900: { id: '23152900', name: 'Packaging machinery' },
    42202200: { id: '42202200', name: 'Gamma radiation therapy products' },
    43201900: { id: '43201900', name: 'Media storage device accessories' },
    56131600: {
      id: '56131600',
      name: 'Merchandiser free standing display and accessories'
    },
    49141500: { id: '49141500', name: 'Scuba and snorkeling gear' },
    25174000: { id: '25174000', name: 'Engine coolant system' },
    42251500: {
      id: '42251500',
      name:
        'Cognitive and dexterity and perceptual and sensory evaluation and therapy products'
    },
    42181600: { id: '42181600', name: 'Blood pressure units and related products' },
    52151600: { id: '52151600', name: 'Domestic kitchen tools and utensils' },
    20101900: { id: '20101900', name: 'Secondary rock breaking systems' },
    25201700: { id: '25201700', name: 'Flight communications related systems' },
    40151500: { id: '40151500', name: 'Pumps' },
    25172500: { id: '25172500', name: 'Tires and tire tubes' },
    15131600: { id: '15131600', name: 'Fission fuel assemblies' },
    45111700: {
      id: '45111700',
      name: 'Audio presentation and composing equipment and hardware and controllers'
    },
    42295500: {
      id: '42295500',
      name:
        'Surgical implants and expanders and extenders and surgical wires and related products'
    },
    60121400: { id: '60121400', name: 'Picture framing' },
    27113100: { id: '27113100', name: 'Pulling tools' },
    30161500: { id: '30161500', name: 'Wall finishing materials' },
    42211800: {
      id: '42211800',
      name: 'Dressing and grooming aids for the physically challenged'
    },
    42231600: {
      id: '42231600',
      name: 'Gastrostomy and jejunostomy access devices or accessories'
    },
    42141800: { id: '42141800', name: 'Electrotherapy equipment' },
    23242300: { id: '23242300', name: 'Lathes and turning centers' },
    41101500: {
      id: '41101500',
      name: 'Laboratory blending and dispersing and homogenizing equipment and supplies'
    },
    41114600: {
      id: '41114600',
      name: 'Metals and metallurgy and structural materials testing instruments'
    },
    23181500: { id: '23181500', name: 'Food preparation machinery' },
    32111500: { id: '32111500', name: 'Diodes' },
    41102500: {
      id: '41102500',
      name: 'Laboratory entomological equipment and accessories'
    },
    26112000: { id: '26112000', name: 'Clutch parts and accessories' },
    47131800: { id: '47131800', name: 'Cleaning and disinfecting solutions' },
    60122500: { id: '60122500', name: 'Paper crafts and hand made papermaking' },
    42292100: {
      id: '42292100',
      name: 'Surgical inserters and extractors and related products'
    },
    42261600: { id: '42261600', name: 'Autopsy equipment and supplies' },
    41113800: { id: '41113800', name: 'Geophysical and geotechnical instruments' },
    41104100: {
      id: '41104100',
      name: 'Specimen collection and transport containers and supplies'
    },
    44103200: { id: '44103200', name: 'Office time recording machines and accessories' },
    42192400: {
      id: '42192400',
      name: 'Medical equipment transport and transfer products'
    },
    42232000: {
      id: '42232000',
      name: 'Tablet crushers and cutters and related products'
    },
    41122500: { id: '41122500', name: 'Laboratory corks and stoppers and accessories' },
    25101900: { id: '25101900', name: 'Specialized and recreational vehicles' },
    23242400: { id: '23242400', name: 'Machining centers' },
    52151800: { id: '52151800', name: 'Domestic cookware' },
    39111700: { id: '39111700', name: 'Emergency lighting and accessories' },
    42171800: {
      id: '42171800',
      name: 'Emergency medical services airway management equipment'
    },
    23261500: { id: '23261500', name: 'Rapid prototyping machines' },
    41104900: { id: '41104900', name: 'Laboratory filtering equipment and supplies' },
    60122900: { id: '60122900', name: 'Beads or beading accessories' },
    31181700: { id: '31181700', name: 'Packings and glands' },
    20101600: { id: '20101600', name: 'Screens and feeding equipment' },
    40101600: { id: '40101600', name: 'Air circulation and parts and accessories' },
    45141600: { id: '45141600', name: 'Darkroom supplies' },
    60121500: { id: '60121500', name: 'Drawing tools and supplies and accessories' },
    22101800: { id: '22101800', name: 'Aerial lifts' },
    42182800: { id: '42182800', name: 'Medical weight scales' },
    43222700: { id: '43222700', name: 'Telegraph equipment' },
    48102100: { id: '48102100', name: 'Storage and handling equipment and supplies' },
    42262000: { id: '42262000', name: 'Embalming equipment and supplies' },
    20122200: { id: '20122200', name: 'Well testing equipment' },
    42141900: { id: '42141900', name: 'Enema administration supplies' },
    41112200: { id: '41112200', name: 'Temperature and heat measuring instruments' },
    31162100: { id: '31162100', name: 'Anchors' },
    42202500: {
      id: '42202500',
      name:
        'Medical single photon emission computed tomography SPECT equipment and related products'
    },
    25111500: { id: '25111500', name: 'Commercial marine craft' },
    30181500: { id: '30181500', name: 'Sanitary ware' },
    45101800: {
      id: '45101800',
      name: 'Book binding and sewing equipment and accessories'
    },
    48111400: { id: '48111400', name: 'Currency vending machines' },
    41116200: {
      id: '41116200',
      name: 'Patient point of care testing supplies and equipment'
    },
    25174100: { id: '25174100', name: 'Roof systems' },
    45101500: { id: '45101500', name: 'Printing machinery and equipment' },
    42142900: {
      id: '42142900',
      name: 'Vision correction or cosmetic eyewear and related products'
    },
    41101800: {
      id: '41101800',
      name: 'Laboratory electron and solid state physics equipment'
    },
    42144200: { id: '42144200', name: 'Acupuncture equipment' },
    22101500: { id: '22101500', name: 'Earth moving machinery' },
    42152500: { id: '42152500', name: 'General dental supplies' },
    45121500: { id: '45121500', name: 'Cameras' },
    42295300: {
      id: '42295300',
      name: 'Open heart surgical supplies and accessories and related products'
    },
    49141600: { id: '49141600', name: 'Surf and swim equipment and accessories' },
    23181700: { id: '23181700', name: 'Food cooking and smoking machinery' },
    25121600: { id: '25121600', name: 'Railway and tramway cars' },
    52152200: { id: '52152200', name: 'Dishwashing and dish storage accessories' },
    42181800: { id: '42181800', name: 'Pulse oximeters' },
    31162400: { id: '31162400', name: 'Miscellaneous fasteners' },
    26101500: { id: '26101500', name: 'Engines' },
    43232200: { id: '43232200', name: 'Content management software' },
    41115600: {
      id: '41115600',
      name: 'Electrochemical measuring instruments and accessories'
    },
    40174400: { id: '40174400', name: 'Pipe spectacle blind flanges' },
    42221600: {
      id: '42221600',
      name: 'Intravenous and arterial tubing and administration sets and related products'
    },
    20142800: { id: '20142800', name: 'Production separators' },
    30171500: { id: '30171500', name: 'Doors' },
    10141500: { id: '10141500', name: 'Saddlery' },
    31171800: { id: '31171800', name: 'Industrial wheels' },
    41105000: {
      id: '41105000',
      name: 'Laboratory sieves and sifting equipment and supplies'
    },
    42121600: { id: '42121600', name: 'Veterinary products' },
    31242200: { id: '31242200', name: 'Miscellaneous optical components' },
    60105400: {
      id: '60105400',
      name:
        'Consumer economics and money management and independent living instructional materials'
    },
    41102700: { id: '41102700', name: 'Crystallography equipment' },
    45121800: { id: '45121800', name: 'Microfilm production equipment and supplies' },
    56121000: { id: '56121000', name: 'Library furnishings' },
    44111500: { id: '44111500', name: 'Organizers and accessories' },
    49181500: { id: '49181500', name: 'Table games and equipment' },
    26141700: { id: '26141700', name: 'Dosimetry equipment' },
    41114700: { id: '41114700', name: 'Paper and wood and textile testing instruments' },
    53112000: { id: '53112000', name: 'Shoe accessories' },
    49131500: { id: '49131500', name: 'Fishing tackle' },
    42294200: { id: '42294200', name: 'Surgical instrument sets and systems and trays' },
    41104000: { id: '41104000', name: 'Sampling equipment' },
    60122000: {
      id: '60122000',
      name: 'Sewing and stitchery and weaving equipment and accessories'
    },
    39121100: {
      id: '39121100',
      name: 'Distribution and control centers and accessories'
    },
    25102100: { id: '25102100', name: 'Truck tractors' },
    40141700: { id: '40141700', name: 'Hardware and fittings' },
    24101800: { id: '24101800', name: 'Dock equipment' },
    43232400: { id: '43232400', name: 'Development software' },
    52151900: { id: '52151900', name: 'Domestic bakeware' },
    42151700: { id: '42151700', name: 'Dental clinical furniture' },
    42292500: {
      id: '42292500',
      name: 'Surgical hammers and mallets and impactors and presses and related products'
    },
    53111900: { id: '53111900', name: 'Athletic footwear' },
    27131500: { id: '27131500', name: 'Pneumatic tools' },
    42142500: {
      id: '42142500',
      name: 'Injection and aspiration needles and accessories'
    },
    40142200: { id: '40142200', name: 'Fluid and gas regulators' },
    41115200: { id: '41115200', name: 'Radar and sonar systems and components' },
    60122700: { id: '60122700', name: 'Enameling paints and accessories' },
    49131600: { id: '49131600', name: 'Hunting products' },
    42291800: {
      id: '42291800',
      name: 'Surgical clamps and forceps and surgical ligators and related instruments'
    },
    20122700: { id: '20122700', name: 'Oil country tubular goods' },
    41101900: { id: '41101900', name: 'Laboratory ionic equipment' },
    42191600: { id: '42191600', name: 'Medical facility building systems' },
    42241700: { id: '42241700', name: 'Orthopedic softgoods for lower extremity' },
    31151700: { id: '31151700', name: 'Mechanical cable' },
    27112800: { id: '27112800', name: 'Tool attachments and accessories' },
    24141500: { id: '24141500', name: 'Securing and protecting supplies' },
    41111900: { id: '41111900', name: 'Indicating and recording instruments' },
    24111500: { id: '24111500', name: 'Bags' },
    42142700: { id: '42142700', name: 'Urological supplies' },
    41112300: { id: '41112300', name: 'Humidity and moisture measuring instruments' },
    11162100: { id: '11162100', name: 'Specialty fabrics or cloth' },
    42203800: { id: '42203800', name: 'Medical radiological positioning aids' },
    42291600: {
      id: '42291600',
      name: 'Surgical cutting instruments and snares and related products'
    },
    44101600: { id: '44101600', name: 'Paper processing machines and accessories' },
    21101600: { id: '21101600', name: 'Agricultural machinery for planting and seeding' },
    42192300: { id: '42192300', name: 'Patient lifts' },
    21102200: { id: '21102200', name: 'Forestry machinery and equipment' },
    42211600: {
      id: '42211600',
      name: 'Bathroom and bathing aids for the physically challenged'
    },
    42251700: { id: '42251700', name: 'Gait training products' },
    41116400: {
      id: '41116400',
      name: 'Acceleration and vibration measuring instruments'
    },
    39121700: { id: '39121700', name: 'Electrical hardware and supplies' },
    44112000: { id: '44112000', name: 'Planning systems' },
    47131600: { id: '47131600', name: 'Brooms and mops and brushes and accessories' },
    41106700: { id: '41106700', name: 'Laboratory botanical equipment and accessories' },
    23251700: { id: '23251700', name: 'Forging machines' },
    26101100: { id: '26101100', name: 'Electric alternating current AC motors' },
    25202100: { id: '25202100', name: 'Flight instrumentation' },
    43223200: { id: '43223200', name: 'Mobile messaging platforms' },
    27113000: { id: '27113000', name: 'Brushes' },
    25171700: { id: '25171700', name: 'Braking systems and components' },
    25201800: { id: '25201800', name: 'Aircraft master control systems' },
    40101700: { id: '40101700', name: 'Cooling equipment and parts and accessories' },
    42151500: { id: '42151500', name: 'Cosmetic dentistry equipment and supplies' },
    41121500: {
      id: '41121500',
      name: 'Pipettes and liquid handling equipment and supplies'
    },
    60103400: {
      id: '60103400',
      name: 'Geography and map skills resources and accessories'
    },
    31241500: { id: '31241500', name: 'Lenses and prisms' },
    25173300: { id: '25173300', name: 'Master control systems' },
    46181500: { id: '46181500', name: 'Safety apparel' },
    41113400: { id: '41113400', name: 'Nuclear evaluation instruments' },
    42132200: { id: '42132200', name: 'Medical gloves and accessories' },
    31191600: { id: '31191600', name: 'Abrasive wheels' },
    23153400: { id: '23153400', name: 'Assembly machines' },
    41103500: { id: '41103500', name: 'Laboratory enclosures and accessories' },
    25101600: { id: '25101600', name: 'Product and material transport vehicles' },
    23131500: {
      id: '23131500',
      name: 'Grinding and sanding and polishing equipment and supplies'
    },
    47121700: { id: '47121700', name: 'Waste containers and accessories' },
    26111700: { id: '26111700', name: 'Batteries and cells and accessories' },
    42294400: { id: '42294400', name: 'Vascular and cardiac systems' },
    26142000: { id: '26142000', name: 'Irradiation equipment' },
    39111500: { id: '39111500', name: 'Interior lighting fixtures and accessories' },
    32101500: {
      id: '32101500',
      name: 'Circuit assemblies and radio frequency RF components'
    },
    42152700: {
      id: '42152700',
      name: 'Orthodontic and prosthodontic equipment and supplies'
    },
    46182400: {
      id: '46182400',
      name: 'Decontamination aids and safety cleaning equipment'
    },
    42142400: { id: '42142400', name: 'Medical suction and vacuum products' },
    27111500: { id: '27111500', name: 'Cutting and crimping and punching tools' },
    42143700: { id: '42143700', name: 'Phototherapy systems and accessories' },
    20102100: { id: '20102100', name: 'Rock drills' },
    41105900: { id: '41105900', name: 'Libraries and related materials' },
    41112400: { id: '41112400', name: 'Pressure measuring and control instruments' },
    41121700: { id: '41121700', name: 'Test Tubes' },
    20142900: { id: '20142900', name: 'Storage vessels and tanks' },
    41111700: {
      id: '41111700',
      name: 'Viewing and observing instruments and accessories'
    },
    41114400: { id: '41114400', name: 'Meteorological instruments' },
    41123000: { id: '41123000', name: 'Laboratory desiccators and desiccants' },
    25172900: { id: '25172900', name: 'Exterior vehicle lighting' },
    49151500: { id: '49151500', name: 'Skiing and snowboarding equipment' },
    32141100: { id: '32141100', name: 'Electron tube parts and accessories' },
    43233500: { id: '43233500', name: 'Information exchange software' },
    49241500: { id: '49241500', name: 'Playground equipment' },
    95141700: {
      id: '95141700',
      name: 'Prefabricated commercial and industrial buildings and structures'
    },
    25201900: { id: '25201900', name: 'Aircraft emergency systems' },
    23201200: { id: '23201200', name: 'Industrial drying equipment' },
    30151600: { id: '30151600', name: 'Roofing accessories' },
    42182600: { id: '42182600', name: 'Medical exam lights or lamps' },
    49221500: { id: '49221500', name: 'Sport accessories' },
    21102300: { id: '21102300', name: 'Greenhouse equipment' },
    42181900: {
      id: '42181900',
      name: 'Acute care monitoring units and related products'
    },
    23161600: { id: '23161600', name: 'Foundry supplies' },
    12131700: { id: '12131700', name: 'Igniters' },
    23101500: {
      id: '23101500',
      name: 'Machinery for working wood and stone and ceramic and the like'
    },
    39112600: { id: '39112600', name: 'Non electrical lighting devices' },
    42142300: { id: '42142300', name: 'Medical documentation products' },
    25191800: { id: '25191800', name: 'Vehicle testing and measuring equipment' },
    42211500: {
      id: '42211500',
      name: 'Ambulation and transfer and positioning aids for the physically challenged'
    },
    12162500: { id: '12162500', name: 'Emulsion breakers' },
    42121800: {
      id: '42121800',
      name: 'Veterinary artificial insemination equipment and supplies'
    },
    46161500: { id: '46161500', name: 'Traffic control' },
    49211700: { id: '49211700', name: 'Bowling equipment and supplies and accessories' },
    42192100: {
      id: '42192100',
      name: 'Clinical seating and stools and related products'
    },
    60102000: {
      id: '60102000',
      name: 'Word building resource materials and accessories'
    },
    52161500: { id: '52161500', name: 'Audio and visual equipment' },
    49211800: { id: '49211800', name: 'Physical education classroom equipment' },
    41122400: { id: '41122400', name: 'Laboratory implements' },
    20101800: { id: '20101800', name: 'Mechanized ground support systems' },
    31161600: { id: '31161600', name: 'Bolts' },
    43211600: { id: '43211600', name: 'Computer accessories' },
    46151700: { id: '46151700', name: 'Forensic equipment and supplies and accessories' },
    41102600: { id: '41102600', name: 'Animal laboratory equipment and accessories' },
    41122000: { id: '41122000', name: 'Laboratory or sampling syringes' },
    42292600: {
      id: '42292600',
      name: 'Surgical dilators and probes and grooves and related products'
    },
    42141700: { id: '42141700', name: 'Decubitus prevention products' },
    42294600: { id: '42294600', name: 'Autotransfusion products' },
    42221700: {
      id: '42221700',
      name: 'Intravenous and arterial infusion bags and containers and related products'
    },
    42231800: { id: '42231800', name: 'Formulas and products for nutritional support' },
    44102400: { id: '44102400', name: 'Labeling machines' },
    60122400: { id: '60122400', name: 'Stained glass making supplies' },
    24102100: { id: '24102100', name: 'Warehousing equipment and supplies' },
    42295000: {
      id: '42295000',
      name: 'Endoscopic equipment and accessories and related products'
    },
    25172800: { id: '25172800', name: 'Hydraulic systems and components' },
    41112800: {
      id: '41112800',
      name: 'Transportation related equipment and instruments'
    },
    20122100: { id: '20122100', name: 'Perforating equipment' },
    25101500: { id: '25101500', name: 'Passenger motor vehicles' },
    27121500: { id: '27121500', name: 'Hydraulic presses' },
    52152000: {
      id: '52152000',
      name: 'Domestic dishes and servingware and storage containers'
    },
    23151700: {
      id: '23151700',
      name: 'Optical industry machinery and equipment and supplies'
    },
    46182000: { id: '46182000', name: 'Respiratory protection' },
    43233000: { id: '43233000', name: 'Operating environment software' },
    42261900: { id: '42261900', name: 'Clinical forensics equipment and supplies' },
    41104300: { id: '41104300', name: 'Fermentation equipment' },
    23151800: {
      id: '23151800',
      name: 'Pharmaceutical industry machinery and equipment and supplies'
    },
    23153100: { id: '23153100', name: 'Industrial machinery components and accessories' },
    42203900: {
      id: '42203900',
      name: 'Medical radiation detection or monitoring products'
    },
    22102000: { id: '22102000', name: 'Building demolition machinery and equipment' },
    23251600: { id: '23251600', name: 'Metal rolling machines' },
    23242600: {
      id: '23242600',
      name: 'Specialized or miscellaneous metal cutting machines'
    },
    43232800: { id: '43232800', name: 'Network management software' },
    49211600: { id: '49211600', name: 'Golf equipment' },
    21101700: { id: '21101700', name: 'Agricultural machinery for harvesting' },
    40101900: { id: '40101900', name: 'Humidity control' },
    23241600: { id: '23241600', name: 'Metal cutting tools' },
    27141000: { id: '27141000', name: 'Body tools' },
    49241600: { id: '49241600', name: 'Recreational equipment' },
    44102800: { id: '44102800', name: 'Binding and lamination machines' },
    46181600: { id: '46181600', name: 'Safety footwear' },
    42172100: {
      id: '42172100',
      name: 'Emergency medical services resuscitation products'
    },
    43201600: { id: '43201600', name: 'Chassis components' },
    21101500: { id: '21101500', name: 'Agricultural machinery for soil preparation' },
    27121800: { id: '27121800', name: 'Hydraulic tools' },
    45111800: {
      id: '45111800',
      name:
        'Video and combination video and audio presentation equipment and hardware and controllers'
    },
    46101500: { id: '46101500', name: 'Firearms' },
    42241600: { id: '42241600', name: 'Casting equipment and parts and accessories' },
    14111800: { id: '14111800', name: 'Business use papers' },
    31162500: { id: '31162500', name: 'Brackets and braces' },
    27112500: { id: '27112500', name: 'Prying and bending tools' },
    27111600: { id: '27111600', name: 'Forming tools' },
    48101500: { id: '48101500', name: 'Cooking and warming equipment' },
    41102900: { id: '41102900', name: 'Histology equipment' },
    44102300: { id: '44102300', name: 'Packing machines' },
    42294500: {
      id: '42294500',
      name: 'Ophthalmic specialty instruments and related products'
    },
    42152000: { id: '42152000', name: 'Dental imaging equipment and supplies' },
    27112400: { id: '27112400', name: 'Fastener setting tools' },
    23153600: { id: '23153600', name: 'Part marking machines' },
    25111600: { id: '25111600', name: 'Safety and rescue water craft' },
    24131500: { id: '24131500', name: 'Industrial refrigerators' },
    55111500: { id: '55111500', name: 'Electronic publications and music' },
    55121600: { id: '55121600', name: 'Labels' },
    42143500: {
      id: '42143500',
      name: 'Ear nose and throat ENT treatment products and accessories'
    },
    39112400: {
      id: '39112400',
      name: 'Stage and studio lighting dimming and control devices'
    },
    43233400: { id: '43233400', name: 'Utility and device driver software' },
    42271700: { id: '42271700', name: 'Oxygen therapy delivery systems and devices' },
    23211100: {
      id: '23211100',
      name: 'Electronic manufacturing and processing machinery'
    },
    26131600: { id: '26131600', name: 'Exhaust structures or screening equipment' },
    42152300: {
      id: '42152300',
      name: 'Dental lasers and illumination and fiber optic equipment and supplies'
    },
    42202400: {
      id: '42202400',
      name: 'Medical positron emission tomography PET equipment and related products'
    },
    41114100: { id: '41114100', name: 'Seismological instruments' },
    20111700: { id: '20111700', name: 'Drilling and operation accessories' },
    60141000: { id: '60141000', name: 'Toys' },
    39121000: { id: '39121000', name: 'Power conditioning equipment' },
    47131500: { id: '47131500', name: 'Cleaning rags and cloths and wipes' },
    48111300: { id: '48111300', name: 'Service and ticket vending machines' },
    41115800: {
      id: '41115800',
      name: 'Clinical and diagnostic analyzers and accessories and supplies'
    },
    24131600: { id: '24131600', name: 'Industrial freezers' },
    23271400: { id: '23271400', name: 'Welding machinery' },
    53121800: { id: '53121800', name: 'Travel kits and accessories' },
    42142200: { id: '42142200', name: 'Hydrotherapy products' },
    31211500: { id: '31211500', name: 'Paints and primers' },
    43191600: {
      id: '43191600',
      name: 'Personal communications device accessories or parts'
    },
    20101700: { id: '20101700', name: 'Crushers and breakers and grinders' },
    46182200: { id: '46182200', name: 'Ergonomic support aids' },
    31151600: { id: '31151600', name: 'Chains' },
    20111600: { id: '20111600', name: 'Drilling and operation machinery' },
    25202600: {
      id: '25202600',
      name: 'Aircraft environmental control systems and components'
    },
    23251500: { id: '23251500', name: 'Metal bending machines' },
    60104200: { id: '60104200', name: 'Water testing and conservation and ecology' },
    43212000: { id: '43212000', name: 'Computer display accessories' },
    23151600: {
      id: '23151600',
      name: 'Cement and ceramics and glass industry machinery and equipment and supplies'
    },
    25111900: { id: '25111900', name: 'Marine craft systems and subassemblies' },
    12131600: { id: '12131600', name: 'Pyrotechnics' },
    46181800: { id: '46181800', name: 'Vision protection and accessories' },
    42292300: {
      id: '42292300',
      name:
        'Surgical bending irons and crimpers and pliers and tensioners and wrenches and related products'
    },
    42241800: {
      id: '42241800',
      name: 'Orthopedic softgoods for upper extremity and torso'
    },
    42293400: {
      id: '42293400',
      name: 'Surgical manipulators and implant positioners and related products'
    },
    24102000: { id: '24102000', name: 'Shelving and storage' },
    43232600: { id: '43232600', name: 'Industry specific software' },
    26141900: { id: '26141900', name: 'Industrial nucleonic instruments' },
    32101600: { id: '32101600', name: 'Integrated circuits' },
    49151600: { id: '49151600', name: 'Skating and ice hockey equipment' },
    42203200: { id: '42203200', name: 'Radiotherapy simulators' },
    49121500: { id: '49121500', name: 'Camping and outdoor equipment' },
    42231700: { id: '42231700', name: 'Nasoenteric tubes' },
    31162600: { id: '31162600', name: 'Hooks' },
    23153800: { id: '23153800', name: 'Coating systems' },
    23281500: { id: '23281500', name: 'Coating or plating machines' },
    60141200: { id: '60141200', name: 'Active play equipment and accessories' },
    44111900: { id: '44111900', name: 'Boards' },
    40161700: { id: '40161700', name: 'Separators' },
    20121300: { id: '20121300', name: 'Sand control equipment' },
    40151600: { id: '40151600', name: 'Compressors' },
    43231600: {
      id: '43231600',
      name: 'Finance accounting and enterprise resource planning ERP software'
    },
    22101700: { id: '22101700', name: 'Heavy equipment components' },
    41113700: {
      id: '41113700',
      name: 'Electronic and communication measuring and testing instruments'
    },
    23281700: { id: '23281700', name: 'Mechanical surface treatment machines' },
    42312000: { id: '42312000', name: 'Medical tissue closure and related products' },
    44121500: { id: '44121500', name: 'Mailing supplies' },
    20101500: { id: '20101500', name: 'Cutting equipment' },
    42201800: { id: '42201800', name: 'Medical diagnostic x ray products' },
    20102200: { id: '20102200', name: 'Explosive loading machinery' },
    44121700: { id: '44121700', name: 'Writing instruments' },
    42204000: {
      id: '42204000',
      name: 'Medical radiological shielding and protection products'
    },
    39111800: { id: '39111800', name: 'Lighting accessories' },
    27112000: { id: '27112000', name: 'Agriculture, forestry and garden handtools' },
    46151600: { id: '46151600', name: 'Security and control equipment' },
    45112000: { id: '45112000', name: 'Microfilm equipment and supplies' },
    42221900: {
      id: '42221900',
      name: 'Intravenous or arterial flow measurement and regulation products'
    },
    39121500: { id: '39121500', name: 'Electrical controls and accessories' },
    32131000: {
      id: '32131000',
      name: 'Electronic component parts and raw materials and accessories'
    },
    25202400: { id: '25202400', name: 'Aircraft fuel tanks and systems' },
    60121300: { id: '60121300', name: 'Art and craft cutting products' },
    42292400: { id: '42292400', name: 'Surgical taps and drivers and related products' },
    42221500: {
      id: '42221500',
      name: 'Intravenous and arterial cannulas and catheters and accessories'
    },
    60121600: { id: '60121600', name: 'Studio aids' },
    41114000: { id: '41114000', name: 'Rock and strata measuring equipment' },
    20122500: { id: '20122500', name: 'Coiled tubing equipment' },
    48101700: { id: '48101700', name: 'Food and beverage dispensing equipment' },
    46161600: { id: '46161600', name: 'Water safety' },
    42271800: {
      id: '42271800',
      name: 'Respiratory humidity and aerosol therapy products'
    },
    42203400: {
      id: '42203400',
      name:
        'Vascular imaging and interventional cardiology and cardiac catheterization lab products'
    },
    39121600: { id: '39121600', name: 'Circuit protection devices and accessories' },
    25172100: {
      id: '25172100',
      name: 'Vehicle safety and security systems and components'
    },
    41112900: { id: '41112900', name: 'Navigational equipment and instruments' },
    41102400: { id: '41102400', name: 'Laboratory heating and drying equipment' },
    43232100: { id: '43232100', name: 'Content authoring and editing software' },
    52141500: { id: '52141500', name: 'Domestic kitchen appliances' },
    41113100: { id: '41113100', name: 'Gas analyzers and monitors' },
    41105200: {
      id: '41105200',
      name: 'Laboratory slide stainer equipment and accessories'
    },
    49171600: { id: '49171600', name: 'Boxing equipment' },
    23121600: {
      id: '23121600',
      name: 'Textile working machinery and equipment and accessories'
    },
    41115500: { id: '41115500', name: 'Sound generating and measuring equipment' }
  }
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case tools.SELECT_TOOL:
      return {
        ...state,
        selectedToolId: action.tool,
        isToolPopupOpened: true
      }

    case tools.DISMISS_TOOL:
      return {
        ...state,
        isToolPopupOpened: false
      }

    default:
      return state
  }
}

export default reducers
